@if (variant === 'vertical-style-2') {
  <app-navbar-vertical-style-2></app-navbar-vertical-style-2>
}
